import React from 'react';
import { Alert, Typography } from '@one-thd/sui-atomic-components';
import { SWEEPSTAKES_CONSTANTS } from '../../../../../core/Constants';

export const ChallengeEndedContent = () => {
  const content = (
    <div className="sui-mt-6" data-testid="sweepstakes-challenge-ended-content">
      <Alert status="info">
        <Typography>
          {SWEEPSTAKES_CONSTANTS.EMPTY_STATE.CHALLENGE_ENDED_MESSAGE}
        </Typography>
      </Alert>
    </div>
  );

  return { content, footer: null };
};

ChallengeEndedContent.propTypes = {};

ChallengeEndedContent.defaultProps = {};
